module.exports = __webpack_public_path__ + "img/Feature.3a43f7fe.png";